import { render, staticRenderFns } from "./merchantAccountDetail.vue?vue&type=template&id=33219502&scoped=true"
import script from "./merchantAccountDetail.vue?vue&type=script&lang=js"
export * from "./merchantAccountDetail.vue?vue&type=script&lang=js"
import style0 from "./merchantAccountDetail.vue?vue&type=style&index=0&id=33219502&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33219502",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33219502')) {
      api.createRecord('33219502', component.options)
    } else {
      api.reload('33219502', component.options)
    }
    module.hot.accept("./merchantAccountDetail.vue?vue&type=template&id=33219502&scoped=true", function () {
      api.rerender('33219502', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/merchantAccount/merchantAccountDetail.vue"
export default component.exports